export default __webpack_public_path__ + "static/media/ฝากสะสมลูกค้าสล็อต.86ca60e9.png";